import React, { useState, useEffect } from 'react';
import '../../components/Footer/Footer.css';
import '../../styles/CustomClassCss/Custom.css';
import logo from '../../assets/images/logostelmart.png';
import Map from '../../assets/images/IndiaMap.png';
import { FaFacebookF, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import { IoCall } from "react-icons/io5";
import { FaChevronUp } from "react-icons/fa";
import { getVisitCount } from '../../API/Api';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [visitStats, setVisitStats] = useState({ total_visits: 0, unique_visitors: 0 });
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  useEffect(() => {
    const fetchVisitCount = async () => {
      try {
        const data = await getVisitCount();
        setVisitStats({
          total_visits: data?.total_visits || 0,
          unique_visitors: data?.unique_visitors || 0
        });
      } catch (error) {
        console.error('Failed to fetch visit count:', error);
      }
    };

    fetchVisitCount();
  }, []);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const goTop = document.querySelector('.go-top');
      if (window.scrollY > 500) {
        goTop.style.display = 'block';
      } else {
        goTop.style.display = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container custom-inner-space custom-container-upper">
        <div className="footer-left font-merriweather">
          <h2>LET'S OPTIMIZE YOUR SUPPLY CHAIN</h2>
          <img src={logo} alt="Logo Stelmart" className="footer-logo" />
        </div>
        <div className="footer-content">
          <div className="font-poppins">
            <p>
              <h3>Address</h3>
              Electrip Private Limited <br />
              H-58, Ground Floor, South City-2<br />
              Sector-50, Gurugram, Haryana-122018 <br />
              Email address: <a href="mailto:info@stelmart.co.in" className="email-link">info@stelmart.co.in</a> <br />
            </p>
          </div>

          <div className="footer-center font-poppins">
            <h3>Solutions</h3>
            <ul>
              <li className="footer-link" onClick={() => navigate('/extensive-product-search')}>Extensive product search</li>
              <li className="footer-link" onClick={() => navigate('/strategic-financing')}>Strategic Financing</li>
              <li className="footer-link" onClick={() => navigate('/supply-chain-management')}>Supply chain management</li>
              <li className="footer-link" onClick={() => navigate('/technical-support')}>Technical support</li>
            </ul>
          </div>

          <div className="footer-company">
            <h3>Quick Links</h3>
            <ul>
              <li className="footer-link" onClick={() => navigate('/about-us')}>About Stelmart</li>
              <li className="footer-link" onClick={() => navigate('/contact-us')}>Contact Us</li>

              {/* <li>Contact Us</li> */}
              {/* <li className="footer-link">Categories</li> */}
              <li className="footer-link" onClick={() => navigate('/blogs')}>Blogs</li>


              <li>
                Visit Count: {visitStats.total_visits} (Unique: {visitStats.unique_visitors})
              </li>            </ul>
          </div>

          <div className="footer-right">
            <div className="footer-map font-space-grotesk">
              <h4>OUR LOCATIONS</h4>
              <img src={Map} alt="Map Stelmart" className="mapsize" />
            </div>
          </div>
        </div>
      </div>

      <hr className="footer-line" />
      <div className='footer-space'>
        <div className="footer-bottom font-rubik">
          <div className="footer-left-content">
            <p>© 2025 All Rights Reserved.</p>
          </div>
          <div className="footer-right-content social-icons custom-container-side">
            <a href="https://www.facebook.com/people/StelMart/61550558870853/" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://in.linkedin.com/company/stelmart" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://www.instagram.com/stelmart2023/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
          </div>
        </div>
        <div className="fixed-contact">
          <a href="tel:+917011588280">
            <button className="btn-floating phone">
              <img src="https://i.imgur.com/FZuns9L.png" alt="Phone" />
              <span>+91 7011588280</span>
            </button>
          </a>

          <a href="https://wa.me/+917011588280" target="_blank" rel="noopener noreferrer">
            <button className="btn-floating whatsapp">
              <img src="https://i.imgur.com/LBW2Lso.png" alt="WhatsApp" />
              <span>+91 7011588280</span>
            </button>
          </a>

          <div className="go-top" onClick={scrollToTop}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000" class="bi bi-chevron-up" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
            </svg>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
